import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const forgePersonalSettingsRoute: InvariantJiraRoute = {
	name: 'forge-spa-personal-settings',
	path: '/jira/settings/personal/apps/:appId/:envId/:route?',
};
